import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeIconButtonModule, ForgeIconModule, ForgeTooltipModule } from "@tylertech/forge-angular";

@Component({
    selector: "cell-edit-overlay",
    templateUrl: "./cellEditOverlay.tmpl.html",
    imports: [
        ClassDirective,
        LayoutAlignDirective,
        LayoutDirective,
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgeTooltipModule,
        NgClass,
    ]
})
export class CellEditOverlay
{

    @Input()
    inlineEdit: boolean;

    @Output()
    doLeaveCellEdit = new EventEmitter<boolean>();

    leaveCellEdit(cancel: boolean): void
    {
        this.doLeaveCellEdit.emit(cancel);
    }
}
